import { createFeatureSelector, createSelector } from '@ngrx/store';
import { JournalState } from './journal.reducer';
import * as fromJournal from './journal.reducer';
import { JournalQuery } from './journal.actions';
import { LoadingState, getError } from 'app/utils/callstate';
import * as _ from 'lodash';
import { JournalEntry } from 'app/api/journal.api.service';

export const selectJournalState = createFeatureSelector<JournalState>('journal');

export const selectJournal = createSelector(
  selectJournalState,
  fromJournal.selectAll
);

export const selectJournalLoading = createSelector(
  selectJournalState,
  journalState => journalState.callState === LoadingState.Loading
);

export const selectJournalLoaded = createSelector(
  selectJournalState,
  journalState => journalState.callState === LoadingState.Loaded
);

export const selectJournalError = createSelector(
  selectJournalState,
  journalState => getError(journalState.callState)
);

export const selectJournalQuery = createSelector(
  selectJournalState,
  journalState => ({
    companyId: journalState.companyId,
    key: journalState.key,
    filter: journalState.filter
  } as JournalQuery)
);

export const selectJournalCompanyId = createSelector(
  selectJournalState,
  journalState => journalState.companyId
);

export const selectJournalCountAnomalies = createSelector(
  selectJournal,
  entries => _.reduce(entries, (count: number, entry: JournalEntry) => {
      if (_.isEmpty(entry.name)) { count += 1; }
      return count;
    }, 0)
);

